import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export const RecoveryCodeResentInfo = () => {
    const { t } = useTranslation();

    return (
        <Alert data-testid="recovery-code-resent-info" severity="info">
            {t('recoveryCodeResentInfo.sentNewEmail')}
        </Alert>
    );
};
